import { useEffect, useRef, useState } from "react";

const SOCIALS = [
  { icon: "ri-weibo-fill", name: "微博" },
  { icon: "ri-wechat-fill", name: "微信" },
  { icon: "ri-qq-fill", name: "QQ" },
  { icon: "ri-share-forward-fill", name: "朋友圈" },
];

export default function ShareButton({ title }: { title: string }) {
  const [open, setOpen] = useState(false);
  const [toast, setToast] = useState("");
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClickOutside = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  useEffect(() => {
    if (!toast) return undefined;
    const timer = setTimeout(() => setToast(""), 2200);
    return () => clearTimeout(timer);
  }, [toast]);

  const copyLink = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(window.location.href);
      } else {
        throw new Error("no clipboard");
      }
      setToast("链接已复制到剪贴板");
    } catch {
      setToast("复制失败，请手动复制地址栏链接");
    }
    setOpen(false);
  };

  const shareTo = (name: string) => {
    setToast(`已模拟分享到${name}`);
    setOpen(false);
  };

  return (
    <div className="relative" ref={wrapperRef}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 px-4 py-2 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 whitespace-nowrap transition-colors cursor-pointer"
      >
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-share-line"></i>
        </span>
        分享
      </button>

      {open && (
        <div className="absolute right-0 top-12 z-30 w-56 rounded-lg border border-background-200 bg-background-50 p-3 animate-rise-in">
          <p className="text-xs text-foreground-400 mb-2 px-1 line-clamp-1">{title}</p>
          <button
            type="button"
            onClick={copyLink}
            className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground-700 hover:bg-background-100 text-left cursor-pointer transition-colors"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-link"></i>
            </span>
            复制链接
          </button>
          <div className="grid grid-cols-4 gap-1 mt-2 pt-2 border-t border-background-200">
            {SOCIALS.map((s) => (
              <button
                key={s.name}
                type="button"
                onClick={() => shareTo(s.name)}
                title={s.name}
                className="flex flex-col items-center gap-1 py-2 rounded-md hover:bg-background-100 cursor-pointer transition-colors"
              >
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={s.icon}></i>
                </span>
                <span className="text-[10px] text-foreground-500">{s.name}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {toast && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 px-4 py-2 rounded-md bg-foreground-950 text-background-50 text-sm animate-rise-in">
          {toast}
        </div>
      )}
    </div>
  );
}